import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ChangeCredentialsComponent } from './change-credentials.component';
import { ChangePasswordComponent } from './change-password.component';
import { DisableTwoFactorComponent } from './disable-two-factor.component';
import * as dayjs from 'dayjs';
import { GlobalService } from 'src/app/api/global.service';
import { CookieService } from 'ngx-cookie-service';
// import { Calendar, CalendarOptions, EventInput, FullCalendarComponent } from '@fullcalendar/angular'; // useful for typechecking

import { Calendar,CalendarOptions  } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';


@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {

 
  calendarOptions: CalendarOptions;
  @ViewChild('tmcalendar') calendarComponent: FullCalendarComponent;
  calendarAPI: Calendar = null;
  events = {
    message: 'Got Data',
    success: '1',
    status_code: 200,
    data: []
  }
  LoadedCalendar = false;

  activeIndex = 'overview';
  detailsIndex = 'name';

  @Input() team_member = {
    guid: '',
    display_name: '',
    skills: [],
    projects: [],
    tasks: [],
    description: '',
    postal_code: '',
    country: '',
    province: '',
    city: '',
    str_address: '',
    website: '',
    fax: '',
    custom_id: '',
    phone_number: '',
    two_factor_phone_number: '',
    two_factor_country_code: '',
    is_admin: false,
    active: false,
    outlook_connected: false,
    outlook_email: '',
    gmail_connected: false,
    gmail_email: '',
    two_factor_enabled: false
  }

  edit_mode = false;
  original_active: boolean;
  original_is_admin: boolean;

  countryCodes: any = null;
  two_factor_editing = false;
  two_factor_started = false;
  two_factor_confirmed = false;
  two_factor_code = '';
  two_factor_phone_number = '';
  two_factor_country_code = '1';
  two_factor_use_sms = true;

  add_skill = {
    text: '',
    colour: '#90ee90'
  }

  cache_enabled = false;

  isConnectingOutlook = false;
  isConnectingGmail = false;

  // ── Permissions tab (firm admins only - API: team_members/{guid}/permissions) ──
  readonly permission_groups = [
    { title: 'Contacts', items: [
      { key: 'contacts_create', label: 'Create' }, { key: 'contacts_update', label: 'Edit' },
      { key: 'contacts_delete', label: 'Delete / restore' },
      
      { key: 'contacts_manage_custom_fields', label: 'Manage global custom fields for contacts' },
      { key: 'contacts_manage_default_folders', label: 'Manage the default folder structure for contacts' },
    { key: 'contacts_manage_access', label: 'Change who can see a contact (visible to all / assigned team members)' }] },
    { title: 'Contact Roles', items: [{ key: 'contact_roles_create', label: 'Create' }, { key: 'contact_roles_update', label: 'Edit' }, { key: 'contact_roles_delete', label: 'Delete' }] },
    { title: 'Companies', items: [
      { key: 'companies_create', label: 'Create' }, { key: 'companies_update', label: 'Edit' },
      { key: 'companies_delete', label: 'Delete / restore' },
      { key: 'companies_manage_custom_fields', label: 'Manage global custom fields for companies' },
      { key: 'companies_manage_default_folders', label: 'Manage the default folder structure for companies' },
          { key: 'companies_manage_access', label: 'Change who can see a company (visible to all / assigned team members)' }] },
    { title: 'Projects', items: [
      { key: 'projects_create', label: 'Create (including repeating schedules)' },
      { key: 'projects_update', label: 'Edit the project itself (details, tags, pause, complete - not its tasks / steps)' },
      { key: 'projects_delete', label: 'Delete' },
      { key: 'projects_manage_health', label: 'Manage project health scoring' },
      { key: 'projects_manage_schedules', label: 'Manage project schedules (open the schedule manager, delete schedules)' }] },
    { title: 'Tags', items: [{ key: 'tags_create', label: 'Create' }, { key: 'tags_update', label: 'Edit' }, { key: 'tags_delete', label: 'Delete' }] },
    { title: 'Internal Statuses', items: [{ key: 'statuses_create', label: 'Create' }, { key: 'statuses_update', label: 'Edit' }, { key: 'statuses_delete', label: 'Delete' }] },
    { title: 'Groups', items: [{ key: 'groups_create', label: 'Create' }, { key: 'groups_update', label: 'Edit' }, { key: 'groups_delete', label: 'Delete' }] },
    { title: 'Project Templates', items: [{ key: 'project_templates_create', label: 'Create' }, { key: 'project_templates_update', label: 'Edit' }, { key: 'project_templates_delete', label: 'Delete' }] },
    { title: 'E-Signature Templates', items: [{ key: 'document_templates_create', label: 'Create' }, { key: 'document_templates_update', label: 'Edit' }, { key: 'document_templates_delete', label: 'Delete' }] },
    { title: 'Form Templates', items: [{ key: 'form_templates_create', label: 'Create' }, { key: 'form_templates_update', label: 'Edit' }, { key: 'form_templates_delete', label: 'Delete' }] },
    { title: 'Email Templates', items: [{ key: 'email_templates_create', label: 'Create' }, { key: 'email_templates_update', label: 'Edit' }, { key: 'email_templates_delete', label: 'Delete' }] },
    { title: 'Project Schedule Templates', items: [
      { key: 'schedule_templates_read', label: 'View schedules created from a template' },
      { key: 'schedule_templates_update', label: 'Update schedule templates (and their upcoming projects)' }] },
    { title: 'Activity Log', items: [{ key: 'activity_log_read', label: 'View' }] },
    { title: 'Billing', items: [
      { key: 'billing_create', label: 'Create' }, { key: 'billing_read', label: 'View' },
      { key: 'billing_update', label: 'Edit' }, { key: 'billing_delete', label: 'Delete' }] },
    // The Time groups are only listed for firms with time and billing switched on (see the template: every group whose title
    // starts with "Time"). All of these are independent of each other.
    { title: 'Time - My Time Entries', items: [
      { key: 'time_own_create', label: 'Create time entries for themselves' }, { key: 'time_own_update', label: 'Edit time entries for themselves' },
      { key: 'time_own_delete', label: 'Delete time entries for themselves' }] },
    { title: 'Time - Other Team Members', items: [
      { key: 'time_others_view', label: 'View time entries for other team members' },
      { key: 'time_others_create', label: 'Create time entries for other team members' },
      { key: 'time_others_update', label: 'Edit time entries for other team members' },
      { key: 'time_others_delete', label: 'Delete time entries for other team members' }] },
    // Without "View Billing Rates" a team member can't see a billing rate or an amount anywhere (the billing section of a time
    // entry, the rate / amount columns, the Time Tracking list), so creating / editing / deleting rates needs it too.
    { title: 'Time - Billing Rates', items: [
      { key: 'time_billing_view', label: 'View Billing Rates' },
      { key: 'billing_rates_create', label: 'Create billing rates' }, { key: 'billing_rates_update', label: 'Edit billing rates' },
      { key: 'billing_rates_delete', label: 'Delete billing rates' }] },
    { title: 'Time - Work Codes', items: [
      { key: 'work_codes_create', label: 'Create work codes' }, { key: 'work_codes_update', label: 'Edit work codes' },
      { key: 'work_codes_delete', label: 'Delete work codes' }] },
    { title: 'Time - Tags', items: [
      { key: 'time_tags_create', label: 'Create tags' }, { key: 'time_tags_update', label: 'Edit tags' },
      { key: 'time_tags_delete', label: 'Delete tags' }] },
    { title: 'Other Team Members', items: [
      { key: 'team_members_create', label: 'Add' }, { key: 'team_members_update', label: 'Edit / activate' },
      { key: 'team_members_delete', label: 'Delete / restore' }] },
  ];
  team_member_permissions: any = null;

  // For now Create on contacts / companies always includes Edit: shown as on and locked here, and saved as on
  // (SaveTeamMemberPermissions). Remove the pairs below to make Edit separate again.
  private readonly create_includes_update: { [included_key: string]: string[] } = {
    contacts_update: ['contacts_create'],
    companies_update: ['companies_create'],
  };
  // Permissions that can't be on without another one: no rates can be created / edited / deleted by someone who can't see them
  private readonly requires_permission: { [key: string]: string } = {
    billing_rates_create: 'time_billing_view',
    billing_rates_update: 'time_billing_view',
    billing_rates_delete: 'time_billing_view',
  };

  // The permission this one needs, when that one is off (the checkbox is then off and can't be ticked)
  MissingRequiredPermission(key: string): string {
    const required = this.requires_permission[key];
    return required && !this.team_member_permissions?.[required] ? required : '';
  }

  // Turning View Billing Rates off turns off what needs it
  OnPermissionChange(key: string) {
    if (this.team_member_permissions?.[key]) return;
    Object.keys(this.requires_permission)
      .filter(dependent => this.requires_permission[dependent] === key)
      .forEach(dependent => { this.team_member_permissions[dependent] = false; });
  }

  IncludedByCreate(key: string): boolean {
    const source_keys = this.create_includes_update[key];
    return !!source_keys && source_keys.some(source => !!this.team_member_permissions?.[source]);
  }
  permissions_saving = false;

  async LoadTeamMemberPermissions() {
    this.team_member_permissions = null;
    const data: any = await this.apiService.get(`team_members/${this.team_member.guid}/permissions`);
    if (data?.success && data.data?.[0]) this.team_member_permissions = data.data[0];
    else this.globalService.presentToastMessage(data?.message || 'Failed to load permissions', false);
  }

  async SaveTeamMemberPermissions() {
    if (!this.team_member_permissions) return;
    const body: any = {};
    for (const group of this.permission_groups)
      for (const item of group.items) body[item.key] = (!!this.team_member_permissions[item.key] || this.IncludedByCreate(item.key)) && !this.MissingRequiredPermission(item.key);

    this.permissions_saving = true;
    const data: any = await this.apiService.put(`team_members/${this.team_member.guid}/permissions`, body);
    this.permissions_saving = false;
    if (data?.success && data.data?.[0]) {
      this.team_member_permissions = data.data[0];
      this.globalService.presentToastMessage('Permissions saved', true);
    } else {
      this.globalService.presentToastMessage(data?.message || 'Failed to save permissions', false);
    }
  }

  // Edit/activate another team member: admins, or team_members_update - but never on an admin (the API enforces the same)
  get can_manage_this_team_member(): boolean {
    const me = this.globalService.GetCurrentUser();
    if (!me) return false;
    if (me.is_admin) return true;
    return this.globalService.Can('team_members_update') && !this.team_member.is_admin;
  }

  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService, private cookieService: CookieService) { }

  ngOnInit() {
    const val = this.cookieService.get('cache_off');
    this.cache_enabled = val === 'false';
    this.GetData();
  }

  // The OAuth redirect back into the app is a full page load, so this modal (opened over whatever
  // page the user was on) is gone by the time the browser lands back here - tack a your_account=open
  // marker onto the return_url so top-navbar.component.ts's ngOnInit knows to reopen it, then strips
  // the marker back out of the address bar.
  private BuildYourAccountReturnUrl(): string {
    const url = new URL(window.location.href);
    url.searchParams.set('your_account', 'open');
    return url.toString();
  }

  async ConnectOutlook() {
    this.isConnectingOutlook = true;
    let data: any = await this.apiService.get('outlook/authorize?return_url=' + encodeURIComponent(this.BuildYourAccountReturnUrl()));
    if (data.success && data.data?.[0]?.url) {
      window.location.href = data.data[0].url;
    } else {
      this.isConnectingOutlook = false;
      this.globalService.presentToastMessage(data.message || 'Could not start the Outlook connection.', false);
    }
  }

  async DisconnectOutlook() {
    let data: any = await this.apiService.delete('outlook/disconnect', {});
    if (data.success) {
      this.team_member.outlook_connected = false;
      this.team_member.outlook_email = '';
      this.globalService.presentToastMessage('Outlook account disconnected.', true);
    } else {
      this.globalService.presentToastMessage(data.message || 'Could not disconnect the Outlook account.', false);
    }
  }


  async ConnectGmail() {
    this.isConnectingGmail = true;
    let data: any = await this.apiService.get('gmail/authorize?return_url=' + encodeURIComponent(this.BuildYourAccountReturnUrl()));
    if (data.success && data.data?.[0]?.url) {
      window.location.href = data.data[0].url;
    } else {
      this.isConnectingGmail = false;
      this.globalService.presentToastMessage(data.message || 'Could not start the Gmail connection.', false);
    }
  }

  async DisconnectGmail() {
    let data: any = await this.apiService.delete('gmail/disconnect', {});
    if (data.success) {
      this.team_member.gmail_connected = false;
      this.team_member.gmail_email = '';
      this.globalService.presentToastMessage('Gmail account disconnected.', true);
    } else {
      this.globalService.presentToastMessage(data.message || 'Could not disconnect the Gmail account.', false);
    }
  }

  SetCacheEnabled(enabled: boolean) {
    this.cache_enabled = enabled;
    this.cookieService.set('cache_off', enabled ? 'false' : 'true', 365, '/');
    this.apiService.force_get_data = !enabled;
  }

  ngAfterViewInit() {
    console.log("After View");
  }

  //ORDER IS IMPORTANT
  async GetData() {
    await this.GetDetails();
  }

  async LoadCountryCodes() {
    this.countryCodes = await this.apiService.getSpecificURL('https://app.fusionworkflow.com/assets/files/CountryCodes.json');
    if (this.countryCodes && this.countryCodes.length > 0) {
      this.countryCodes = this.countryCodes.map(country => ({
        ...country,
        dial_code: (country.dial_code || '').toString().replace(/^\+/, '')
      }));
      this.countryCodes = [...this.countryCodes].sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    }
  }


  // Whether this team member gets the emails about client activity (null until it has loaded). Only their own can be changed.
  email_client_activity: boolean | null = null;

  async LoadEmailPreferences() {
    if (this.globalService.GetCurrentUser()?.guid !== this.team_member?.guid) return;
    const data: any = await this.apiService.get('team_members/details/email_preferences');
    this.email_client_activity = data?.success && data.data?.[0] ? !!data.data[0].email_client_activity : true;
  }

  async SetEmailClientActivity(value: boolean) {
    const previous = this.email_client_activity;
    this.email_client_activity = value;
    const data: any = await this.apiService.put('team_members/details/email_preferences', { email_client_activity: value });
    if (!data?.success) {
      this.email_client_activity = previous;
      this.globalService.presentToastMessage(data?.message || 'Could not save your email preference', false);
    }
  }

  async GetDetails() {
    console.log(this.team_member);
    let data: any = await this.apiService.get(`team_members/${this.team_member.guid}`);
    if (data.success) {
      console.log("Success");
      this.team_member = data.data[0];
      //make the object cleaner
      if (!this.team_member.skills) this.team_member.skills = [];
      if (!this.team_member.projects) this.team_member.projects = [];
      if (!this.team_member.tasks) this.team_member.tasks = [];

      this.LoadEmailPreferences();

      // Snapshot so UpdateBasicInfo() can tell whether these changed and need their own API calls -
      // the generic team_members update only touches the user_details table, not active/is_admin.
      this.original_active = this.team_member.active;
      this.original_is_admin = this.team_member.is_admin;

      if (!this.two_factor_editing) {
        this.two_factor_phone_number = this.team_member.two_factor_phone_number || this.team_member.phone_number || '';
        this.two_factor_country_code = this.team_member.two_factor_country_code || this.globalService.GetCurrentUser()?.country_code || '1';
        this.FormatTwoFactorPhone();
      }
    }
  }

  



  GoToStep(step) {
    this.activeIndex = step;
    if (step === 'permissions') this.LoadTeamMemberPermissions();
  }

  GoToStepDetails(step) {
    this.detailsIndex = step;
  }

  async Close() {
    if (this.two_factor_editing) {
      window.alert('You have unsaved two factor authentication changes. Please confirm or cancel those changes before closing.');
      return;
    }
    this.modalController.dismiss(this.team_member);
  }


  //When they are trying to update the basic information about the company
  async CancelUpdate() {
    this.edit_mode = false;
    // The checkboxes are bound directly to team_member.active/is_admin, so revert any unsaved toggle
    this.team_member.active = this.original_active;
    this.team_member.is_admin = this.original_is_admin;
  }

  async UpdateBasicInfo() {
    this.globalService.presentLoading('Updating user...', 99999999);
    try {
      // active/is_admin have dedicated endpoints with their own side effects (activation emails,
      // admin-only gating, etc.) - the generic team_members update only touches user_details.
      if (this.team_member.active !== this.original_active) {
        const active_data: any = await this.apiService.put(`team_member/${this.team_member.guid}/activate`, { active: this.team_member.active });
        if (active_data.success) {
          this.original_active = this.team_member.active;
        } else {
          this.globalService.presentToastMessage(active_data.message, false);
          this.team_member.active = this.original_active;
        }
      }
      if (this.team_member.is_admin !== this.original_is_admin) {
        const admin_data: any = await this.apiService.put(`team_member/${this.team_member.guid}/admin`, { is_admin: this.team_member.is_admin });
        if (admin_data.success) {
          this.original_is_admin = this.team_member.is_admin;
        } else {
          this.globalService.presentToastMessage(admin_data.message, false);
          this.team_member.is_admin = this.original_is_admin;
        }
      }

      let data: any = await this.apiService.put(`team_members/${this.team_member.guid}`, this.team_member);
      if (data.success) {
        this.edit_mode = false;
      }
    } finally {
      this.globalService.dismissLoading();
    }
  }

  async OpenChangePasswordModal() {
    const modal = await this.modalController.create({
      component: ChangePasswordComponent,
      cssClass: 'small-modal secondary-modal',
      backdropDismiss: false,
      componentProps: { team_member: this.team_member }
    });
    await modal.present();
  }

  async OpenChangeCredentialsModal() {
    const modal = await this.modalController.create({
      component: ChangeCredentialsComponent,
      cssClass: 'small-modal secondary-modal',
      backdropDismiss: false,
      componentProps: { team_member: this.team_member }
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data === true) {
      await this.GetDetails();
    }
  }

  async OpenDisableTwoFactorModal() {
    const modal = await this.modalController.create({
      component: DisableTwoFactorComponent,
      cssClass: 'small-modal secondary-modal',
      backdropDismiss: false,
      componentProps: { team_member: this.team_member }
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data === true) {
      this.team_member.two_factor_enabled = false;
    }
  }

  StartTwoFactorEdit() {
    this.two_factor_editing = true;
    this.two_factor_started = false;
    this.two_factor_confirmed = false;
    this.two_factor_code = '';
    this.two_factor_phone_number = this.team_member.two_factor_phone_number || this.team_member.phone_number || '';
    this.two_factor_country_code = this.team_member.two_factor_country_code || this.globalService.GetCurrentUser()?.country_code || '1';
    this.FormatTwoFactorPhone();
  }

  CancelTwoFactorEdit() {
    this.two_factor_editing = false;
    this.two_factor_started = false;
    this.two_factor_confirmed = false;
    this.two_factor_code = '';
  }

  FormatTwoFactorPhone() {
    this.two_factor_phone_number = this.globalService.FormatPhoneNumber(this.two_factor_phone_number);
  }

  async StartTwoFactor() {
    if (!this.two_factor_phone_number) {
      this.globalService.presentToastMessage('Must enter a phone number', false);
      return;
    }
    if (!this.two_factor_country_code) {
      this.globalService.presentToastMessage('Must select a country code', false);
      return;
    }

    const countryCode = this.two_factor_country_code.toString().replace(/^\+/, '');
    const post_data = {
      phone_number: this.two_factor_phone_number,
      country_code: countryCode,
      use_sms: this.two_factor_use_sms
    };
    this.globalService.presentLoading('Starting Two Factor Authentication...', 9999999);
    let data: any = await this.apiService.post('team_members/details/two_factor/create', post_data);
    this.globalService.dismissLoading();
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      this.two_factor_started = true;
    }
  }

  async ConfirmTwoFactor() {
    if (this.two_factor_code == '') {
      this.globalService.presentToastMessage('Must enter a code', false);
      return;
    }
    this.globalService.presentLoading('Confirming Code...', 9999999);
    let data: any = await this.apiService.post('team_members/details/two_factor/confirm', { code: this.two_factor_code });
    this.globalService.dismissLoading();
    if (data.success) {
      this.two_factor_confirmed = true;
      this.two_factor_editing = false;
      this.GetDetails();
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }


  //Skills
  //Present the modal to select skills to apply to the company
  async presentSelectSkillsModal() {
    let skills_copy = JSON.stringify(this.team_member.skills);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'team_members',
        selected_tags: this.team_member.skills,
        title: "Select Skills",
        source_header: "Avaliable Skills",
        target_header: "Assigned Skills",
        name: "Skill"
      }
    })
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        skills_copy = JSON.parse(skills_copy);
        this.CheckSkills(skills_copy, data.data);
      }
      else {
        this.team_member.skills = [...JSON.parse(skills_copy)];
      }
    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckSkills(old_skills, new_skills) {
    //Check to see if all the old tags still exist, if not we will run a delete statement to the api
    old_skills.forEach(skill => {
      const index = new_skills.findIndex(e => skill.guid === e.guid);
      if (index == -1) {
        console.log(skill);
        this.RemoveSkill(skill);
      }
    });
    //If the old tag does not exist in the new tags, run api statement to add it
    new_skills.forEach(skill => {
      const index = old_skills.findIndex(e => skill.guid === e.guid);
      if (index == -1) {
        this.AddSkill(skill);
      }
    });
  }
  async RemoveSkill(skill) {
    let data: any = await this.apiService.delete(`team_members/skills/${this.team_member.guid}`, skill);
  }
  async AddSkill(skill) {
    let data: any = await this.apiService.post(`team_members/skills/${this.team_member.guid}`, skill);
  }

}
